module.exports = __webpack_public_path__ + "images/inAppPurchaseIcon-04d4b3a62205d68dc4fedbeda99cb051.svg";